import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as widgetActions from '../redux/supervisor_time_off_pending_widget_actions';
import * as supervisorActions from '../redux/supervisor_time_off_actions';
import * as actions from '../redux/time_off_actions';
import { CFDateRangePicker } from 'datePicker';
import moment from 'moment-timezone';

export class TimeOffSummaryWidget extends Component{
    constructor(props) {
        super(props)
        this.state = { 
            singleDate: moment(),
            availablSpots: 0,
            approvedSpots: 0,
            pendingSpots: 0,
            scheduledAgentsByDate:[]
        } 
        this.setSelectedDate = this.setSelectedDate.bind(this)    

        if(this.props.actions && props.actions.fetchPTOSpotsAction && this.props.managementUnitID > -1)
         props.actions.fetchPTOSpotsAction({ 
             managementUnitID: props.managementUnitID,
             startDate: moment().startOf('day').format(),
             endDate: moment().startOf('day').format() 
        })

        this.setSelectedDate = this.setSelectedDate.bind(this);   
        this.isDayHighlighted = this.isDayHighlighted.bind(this);  
        if(this.props.managementUnitID > -1){
            var requestParameters = {
                Page: 1,
                PageSize: 9999,
                SortOrder: 'desc',
                SortColumn: 'DateCreated',
                customFilters: [
                    { "PropertyName": "ManagementUnitID", "Operation": 1, "Value": props.managementUnitID },
                    { "PropertyName": "RequestStatus", "Operation": 1, "Value": "1" },
                    { "PropertyName": "StartDate", "Operation": 10, "Value":  moment().startOf('day').format() }
                ]
            }        
            this.props.actions.fetchCurrentRequestsAction(requestParameters, true);
        }

    }    
    componentWillReceiveProps(nextProps){
        if(this.props.ptoSpots[0] !== nextProps.ptoSpots[0]){
            this.setState({
                availablSpots: nextProps.ptoSpots[0].available_spots,
                approvedSpots: nextProps.ptoSpots[0].approved_spots,
                pendingSpots: nextProps.ptoSpots[0].pending_spots
            })
        }
        if((this.props.managementUnitID !== nextProps.managementUnitID 
            && nextProps.managementUnitID > -1)
            || (nextProps.isRefreshNeeded
                && nextProps.managementUnitID > -1)){
            nextProps.actions.fetchPTOSpotsAction({ 
                managementUnitID: nextProps.managementUnitID,
                startDate: this.state.singleDate.startOf('day').format(),
                endDate: this.state.singleDate.startOf('day').format() 
           })
           if(nextProps.managementUnitID > -1){
            var requestParameters = {
                    Page: 1,
                    PageSize: 9999,
                    SortOrder: 'desc',
                    SortColumn: 'DateCreated',
                    customFilters: [
                        { "PropertyName": "ManagementUnitID", "Operation": 1, "Value": nextProps.managementUnitID },
                        { "PropertyName": "RequestStatus", "Operation": 1, "Value": "1" },
                        { "PropertyName": "StartDate", "Operation": 10, "Value":  this.state.singleDate.startOf('day').format() }
                    ]
                }
                this.props.actions.fetchCurrentRequestsAction(requestParameters, true);
            }
        }
        if(this.props.approvedRequests !== nextProps.approvedRequests){
            this.setState({
                scheduledAgentsByDate: nextProps.approvedRequests
            })
        }

        if(nextProps.managementUnitID === -1){
            this.setState({
                availablSpots: 0,
                approvedSpots: 0,
                pendingSpots: 0,
                scheduledAgentsByDate:[]
            })
        }
    }


    setSelectedDate(startDate){       
        this.setState({ singleDate: startDate });

        if(this.props.actions 
            && this.props.actions.fetchPTOSpotsAction 
            && this.props.managementUnitID > -1)
        this.props.actions.fetchPTOSpotsAction({ 
            managementUnitID: this.props.managementUnitID,
            startDate: startDate.startOf('day').format('YYYY-MM-D'),
            endDate: startDate.startOf('day').format('YYYY-MM-D') 
       })
       if(this.props.managementUnitID > -1){
        var requestParameters = {
                Page: 1,
                PageSize: 9999,
                SortOrder: 'desc',
                SortColumn: 'DateCreated',
                customFilters: [
                    { "PropertyName": "ManagementUnitID", "Operation": 1, "Value": this.props.managementUnitID },
                    { "PropertyName": "RequestStatus", "Operation": 1, "Value": "1" },
                    { "PropertyName": "StartDate", "Operation": 10, "Value":  startDate.startOf('day').format('YYYY-MM-D') }
                ]
            }
            this.props.actions.fetchCurrentRequestsAction(requestParameters, true);
        }
    }
    

    isDayHighlighted(date) {   
        if(this.props.unavailableDates.length > 0){
            for(let i = 0; i < this.props.unavailableDates.length; i++)
            {
                if(date.isSame(this.props.unavailableDates[i], 'day'))
                    return true;
            }      
        }
        return false;       
    }
    render(){

        let scheduledAgents = this.state.scheduledAgentsByDate.map((item, index) => {           
                return <ScheduledAgentRow key={index}
                    item={item} />
            })
        
        
        return(
            <div className="time_off_request_summary_container">
                <div className="calendar_container_widget">
                    <CFDateRangePicker                    
                        singleDate={this.state.singleDate}                            
                        isSingleDayPicker={true}
                        isDayHighlighted={(date) => this.isDayHighlighted(date)}
                        onDateChange ={this.setSelectedDate}
                        availableEnd={moment().add(1, 'year')}
                        availableStart={moment().add(-6, 'months')}
                    />
                </div>
                <div className="day_summary_widget">
                    <span className="day">
                        {this.state.singleDate.format('dddd MMMM DD, YYYY')}
                    </span>
                    <div className="pto_counter">
                        <span className="number">{this.state.availablSpots}</span>
                        <span className="counter_label">Available Spots</span>
                    </div>
                    <div className="pto_counter">
                        <span className="number">{this.state.approvedSpots}</span>
                        <span className="counter_label">Approved Requests</span>
                    </div>
                    <div className="pto_counter">
                        <span className="number">{this.state.pendingSpots}</span>
                        <span className="counter_label">Pending Requests</span>
                    </div>
                </div>
                <div className="day_summary_widget">
                    <div className="scheduled_header">
                        <span className="heading left"> Scheduled Time Off</span>
                        <span className="heading agent_count right"> {scheduledAgents.length} Agents</span>
                    </div>                  
                    {scheduledAgents.length > 0 ? scheduledAgents : ''}
                </div>
            </div>
            )
        }
}

const ScheduledAgentRow = ({item, ...rest}) => (

    <div className="scheduled_row">
        <div className="scheduled_col first">                        
            <span className="counter_label">{item.agentName}</span>
        </div>
        <div className="scheduled_col second">                        
            <span className="counter_label">{item.startDate} - {item.endDate}</span>
        </div>
        <div className="scheduled_col third">                        
            <span className="counter_label">
                    {item.timeoffValue}
                 </span>
        </div>
    </div>
)



function mapStateToProps(state) {
	return {
        ptoSpots: state.timeoff.ptoSpots,
        approvedRequests: state.timeoff.approvedRequests,
        EnumItems: state.timeoff.EnumItems        
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...widgetActions, ...supervisorActions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TimeOffSummaryWidget);



// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/TimeOffSummaryWidget.js